import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import items from "../../utils/itemData";
import Button from "../Button";
import * as SC from "../MasterCss";
import { SoundContext } from "../../context/SoundContext";
import {getValidItemsForGameType} from "../../utils/gameUtils";
import { getItemName, getItemFact, getBinName } from "../../utils/i18nHelpers";

const SuccessBox = styled.div`
  background-color: rgba(36, 174, 95, 0.7);
  padding: 3em;
  width: 100vw;
  height: 100vh;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1500;
  padding: 0px;
`;

const SuccessModal = props => {
  const { playSound } = useContext(SoundContext);
  const { t } = useTranslation();
  useEffect(() => {
    playSound("success");
  }, [playSound]);  

  const handleClose = () => {
    props.setSuccessModal(false);
    props.pickNextItem();
  };

  const item = props.item;

  const itemName = getItemName(t, item);
  const itemFact = getItemFact(t, item);
  const binName = getBinName(t, item.bin);

  const isSpecialBin = ['yard waste', 'special programs'].includes(item.bin.toLowerCase());
  const messageKey = isSpecialBin ? 'successModal.messageWithoutBin' : 'successModal.messageWithBin';
  return (
    <SuccessBox id="success" onClick={handleClose}>
      <SC.ModalHeader>{t('successModal.title')}</SC.ModalHeader>
      <SC.ModalHeader>
        {t(messageKey, {
          itemName,
          binName
        })}
      </SC.ModalHeader>
      <SC.BadgeBox>
        
        <SC.MessageBox expand>
        <SC.MessageImage alt={itemName} src={item.src} />
        <SC.BoxMessage>{itemFact}</SC.BoxMessage>
        </SC.MessageBox>
      </SC.BadgeBox>
      <Button primary handleClick={handleClose} label={t('successModal.okButton')} />
    </SuccessBox>
  );
};

export default SuccessModal;
